import {Validate} from "class-validator";
import {CustomIdDTO} from "../common/id-validator.dto";
import {Sim} from "../../sim";

export class AssignSimDTO {

    @Validate(CustomIdDTO)
    id : number;


    constructor(sim: Sim)  {
        this.id = sim.id!;
    }

}

